import { APP_BASE_HREF } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi, withJsonpSupport } from '@angular/common/http';
import { APP_ID, ApplicationConfig } from '@angular/core';

import { CURRENCY_PROVIDER, GRAPHQL_PROVIDERS, USER_CONTEXT_LOADER_PROVIDER } from '@hdms/shared/data-access';
import {
  ENVIRONMENT,
  HTTP_INTERCEPTOR_PROVIDERS,
  LOGGER_PROVIDER,
  PRELOADER_CONTROL_PROVIDERS,
  ROUTER_BREADCRUMB_SERVICE_PROVIDER
} from '@hdms/shared/util-core';

import { environment } from '../environments/environment';

import { HDMS_APP_ID } from './constants';
import { APP_TRANSLATION_PROVIDERS } from './i18n/app-translation.providers';
import { APP_ROUTING_PROVIDERS } from './routing/app-routing.providers';
import { URL_SERIALIZER_PROVIDER } from './routing/custom-url.serializer';

/**
 * Providers used in server and browser environment
 */
export const APP_COMMON_CONFIG: ApplicationConfig = {
  providers: [
    provideHttpClient(withJsonpSupport(), withInterceptorsFromDi()),
    { provide: ENVIRONMENT, useValue: environment },
    { provide: APP_ID, useValue: HDMS_APP_ID },
    { provide: APP_BASE_HREF, useValue: '/' },
    PRELOADER_CONTROL_PROVIDERS,
    GRAPHQL_PROVIDERS,
    HTTP_INTERCEPTOR_PROVIDERS,
    APP_ROUTING_PROVIDERS,
    APP_TRANSLATION_PROVIDERS,
    USER_CONTEXT_LOADER_PROVIDER,
    ROUTER_BREADCRUMB_SERVICE_PROVIDER,
    CURRENCY_PROVIDER,
    URL_SERIALIZER_PROVIDER,
    LOGGER_PROVIDER
  ]
};
